"use client";

import { useActionState } from "react";
import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import {
  requestPasswordResetAction,
  type PasswordResetState,
} from "@/lib/actions/password-reset";

const initial: PasswordResetState = {};

export function ForgotPasswordForm() {
  const t = useTranslations("login");
  const [state, action, pending] = useActionState(
    requestPasswordResetAction,
    initial,
  );

  return (
    <form action={action} className="mt-6 max-w-md space-y-4">
      <div className="space-y-1">
        <label htmlFor="email" className="block text-sm font-medium text-stone-800">
          {t("email")}
        </label>
        <input
          id="email"
          name="email"
          type="email"
          autoComplete="email"
          required
          className="w-full rounded-md border border-stone-300 bg-white px-3 py-2 text-stone-900"
        />
      </div>
      {state.error ? (
        <p className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-900">
          {t(`errors.${state.error}`)}
        </p>
      ) : null}
      {state.success ? (
        <p className="rounded-md border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm text-emerald-900">
          {t("forgotSent")}
        </p>
      ) : null}
      <button
        type="submit"
        disabled={pending}
        className="rounded-md bg-stone-900 px-4 py-2.5 text-sm font-medium text-white hover:bg-stone-800 disabled:opacity-60"
      >
        {pending ? t("forgotSubmitting") : t("forgotSubmit")}
      </button>
      <p className="text-sm">
        <Link href="/login" className="underline">
          {t("backToLogin")}
        </Link>
      </p>
    </form>
  );
}
